import xrmApi from "src/services/xrmApi"
import { xRMApiTermsOfService } from "src/types/xRM"

export const fetchToS = async (): Promise<xRMApiTermsOfService[]> => xrmApi
	.get(`/termsofservices?exhibitionId=${process.env.NEXT_PUBLIC_WEBSHOP_XRM_EVENT_ID}`)
	.then(res => res?.data ?? [])
